<template>
  <div>
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <base-header class="pb-2" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col xs="12" lg="6" align="right">
          <router-link to="/user/add-user"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add User</base-button></router-link>
        </b-col>
      </b-row>
    </base-header>
    <div class="container-fluid">
    <b-card body-class="p-0" header-class="border-0">
          <template slot="header">
            <b-row align-h="end">
              <b-col sm="12" lg="4">
                <form @submit.prevent="">
                  <base-input type="search"
                              v-model="sq"
                              placeholder="Search Users">
                  </base-input>
                </form>
              </b-col>
              <b-col sm="12" md="6" lg="4" class="d-flex align-items-left flex-wrap pt-2">
                <p class="mb-0 mr-2 text-sm">Show</p>

                <el-select class="select-primary pagination-select" v-model="perPage" placeholder="Per page">
                  <el-option class="select-primary" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>

                <p class="mb-0 ml-2 text-sm">users</p>

              </b-col>

              <b-col sm="12" md="6" lg="4" class="text-right">
                <a href="#" class="btn-view mr-1 active" @click="toggleActive($event, 'table')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 32 32" fill="#32325d"><path d="M27 4H5C3.3 4 2 5.3 2 7v18c0 1.7 1.3 3 3 3h22c1.7 0 3-1.3 3-3V7c0-1.7-1.3-3-3-3zM13 20v-4h7v4h-7zm7 2v4h-7v-4h7zm0-12v4h-7v-4h7zm8 0v4h-6v-4h6zm-17 4H4v-4h7v4zm-7 2h7v4H4v-4zm18 0h6v4h-6v-4zM4 25v-3h7v4H5c-.6 0-1-.4-1-1zm23 1h-5v-4h6v3c0 .6-.4 1-1 1z"/></svg>
                </a>

                <a href="#" class="btn-view" @click="toggleActive($event, 'grid')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 50 50" fill="#32325d"><path d="M8.775 24.477h12.914a1 1 0 001-1V10.563a1 1 0 00-1-1H8.775a1 1 0 00-1 1v12.914a1 1 0 001 1zm1-12.914h10.914v10.914H9.775V11.563zM25.861 24.477h12.914a1 1 0 001-1V10.563a1 1 0 00-1-1H25.861a1 1 0 00-1 1v12.914a1 1 0 001 1zm1-12.914h10.914v10.914H26.861V11.563zM8.775 41.563h12.914a1 1 0 001-1V27.648a1 1 0 00-1-1H8.775a1 1 0 00-1 1v12.914a1 1 0 001 1.001zm1-12.915h10.914v10.914H9.775V28.648zM24.861 40.563a1 1 0 001 1h12.914a1 1 0 001-1V27.648a1 1 0 00-1-1H25.861a1 1 0 00-1 1v12.915zm2-11.915h10.914v10.914H26.861V28.648z"/></svg>
                </a>
              </b-col>
            </b-row>
          </template>


      <div v-show="this.loading" class="loading">
        <loading-panel></loading-panel>
      </div>

      <el-table class="table-responsive table-flush table-recipes" header-row-class-name="thead-light" :data="users">
        <el-table-column label="User Name" min-width="315px" prop="name" sortable>
          <template v-slot="{ row }">
            <b-media no-body class="align-items-center">
              <a :href="'/user-profile/' + row.id" class="avatar mr-3 table__avatar">
                <b-img alt="Image placeholder" :src="row.image !== null ? row.image.absoluteUri : '/img/DefaultUser.gif'" rounded="circle" ></b-img>
                <span></span>
              </a>
              <b-media-body class="table__title-wrapper">
                <a :href="'/user-profile/' + row.id"><span class="font-weight-600 name mb-0 text-sm table__title">{{ row.fullNameLastFirst }}</span></a>
              </b-media-body>
            </b-media>
          </template>
        </el-table-column>

        <el-table-column label="Title" prop="title" min-width="150px" sortable class="table__company">
          <template v-slot="{ row }">
              <badge class="badge-dot mr-4" type="">
                <span class="font-weight-600">{{ row.title }}</span>
              </badge>
            </template>
        </el-table-column>

        <el-table-column label="Status" prop="status" min-width="120px" sortable class="table__company">
          <template v-slot="{ row }">
              <badge class="badge-dot mr-4" type="">
                <span class="font-weight-600">{{ row.isActive ? "Active" : "Inactive" }}</span>
              </badge>
            </template>
        </el-table-column>

        <el-table-column label="User Type" prop="securityLevel" min-width="120px" sortable class="table__company">
          <template v-slot="{ row }">
              <badge class="badge-dot mr-4" type="">
                <span class="font-weight-600">{{ securityLevelName(row.securityLevel) }}</span>
              </badge>
            </template>
        </el-table-column>

        <el-table-column label="Actions" min-width="110px">
          <template v-slot="{ $index, row }">
            <el-dropdown trigger="click" class="dropdown">
              <span class="btn btn-sm btn-icon-only text-light mr-0 ml-1">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <b-dropdown-item><router-link :to="'/user-profile/' + row.id">View/Edit</router-link></b-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ count }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="currentPage"
              :per-page="perPage"
              :total="count"
              @change="paginationChanged($event)"
            >
            </base-pagination>
      </div>
    </b-card>
  </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import { BasePagination } from '@/components';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import swal from 'sweetalert2';
import EditProfileForm from '@/views/Pages/UserProfile/EditProfileForm';
import LoadingPanel from '@/components/LoadingPanel.vue';

export default {
  components: {
    BasePagination,
    RouteBreadCrumb,
    LoadingPanel,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditProfileForm
  },
  mounted() {
      this.searchUsers();
      const { dispatch } = this.$store;
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    },
    perPage (val,old) {
      this.currentPage = 1;
      this.searchUsers();
    },
    sq: function (val,old) {
      this.sq = val;
        if (!this.pauseSearch) {
          setTimeout(() => {
            this.currentPage = 1;

            this.searchUsers();
            this.pauseSearch = false;
          }, 800); // 1 sec delay
        }
        this.pauseSearch = true;
    }
  },
  props: ['searchUri','payload'],
  data () {
    return {
      view: 'table',
      itemLimit: '10',
      sq: this.$route.query.sq,
      loading: '',
      pauseSearch: false,
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50]
    }
  },
  computed: {
    ...mapGetters([
      'currentCompany'
    ]),
    currentUser () {
      return this.$store.state.authentication.user.user
    },
    isLoading() {
      return this.$store.state.users.loading
    },
    users() {
      return this.$store.state.users.all.results;
    },
    count() {
      return this.$store.state.users.all.count;
    },
    to() {
      let highBound = this.from + this.perPage;
      if (this.count < highBound) {
        highBound = this.count;
      }
      return highBound;
    },
    from() {
      return this.perPage * (this.currentPage - 1);
    }
  },
  methods: {
     paginationChanged(page) {
      this.currentPage = page;
      this.searchUsers();
     },
     handleDelete(index, row) {
      swal.fire({
        title: 'Are you sure you want to delete ' + row.fullNameFirstLast + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, I\'m sure!',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const { dispatch } = this.$store;
          dispatch("users/deleteUser", row.id).then(response => {
            this.deleteRow(row);
            // swal.fire({
            //   title: 'User Deleted',
            //   type: 'success',
            //   confirmButtonClass: 'btn btn-success btn-fill',
            //   buttonsStyling: false
            // });
          })
          .catch(error => {
            return error;
          });
        }
      });
    },
    deleteRow(row) {
      // todo: delete fom API
      let indexToDelete = this.users.findIndex((user) => user.id === row.id);
      if (indexToDelete >= 0) {
        this.users.splice(indexToDelete, 1);
      }
    },
    searchUsers() {
      const { dispatch } = this.$store;
      var payload = {
        "page": this.currentPage,
        "pageSize": this.perPage,
        "query": this.sq
      }

      dispatch("users/getAll",payload);
    },
    securityLevelName(level) {
      switch(level) {
        case 1:
          return "User";
          break;
        case 2:
          return "Admin";
          break;
        case 3:
          return "System";
          break;
        case 5:
          return "Chef";
          break;
      }
    }
  },
  created() {
    const { dispatch } = this.$store;
    dispatch("users/getAll");
  }
}
</script>
<style>
</style>
